module.exports = __webpack_public_path__ + "img/04李辉.1ffbd532.png";